import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M27.879 14.054a.954.954 0 0 0-1.455.704c-.341 3.048-.513 6.268-.515 9.66-.003 3.373.163 6.55.496 9.535a.954.954 0 0 0 1.454.704l14.558-9.086a1.43 1.43 0 0 0 0-2.429L27.88 14.054Zm1.012-1.618 14.538 9.087a3.34 3.34 0 0 1-.001 5.667L28.87 36.276a2.863 2.863 0 0 1-4.363-2.111c-.34-3.057-.51-6.307-.508-9.748.003-3.461.179-6.752.528-9.872a2.863 2.863 0 0 1 4.364-2.11ZM6.879 14.054a.955.955 0 0 0-1.454.704c-.342 3.048-.514 6.268-.516 9.66-.002 3.373.163 6.55.496 9.535a.954.954 0 0 0 1.454.704l14.558-9.086a1.432 1.432 0 0 0 .001-2.429L6.88 14.054Zm1.012-1.618 14.539 9.087a3.34 3.34 0 0 1-.002 5.667L7.87 36.276a2.864 2.864 0 0 1-4.362-2.111c-.341-3.057-.51-6.307-.508-9.748.002-3.461.178-6.752.528-9.872a2.864 2.864 0 0 1 4.363-2.11Z",
      clipRule: "evenodd"
    }
  )
);
var SvgFastForwardOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FastForwardOutlined_default = SvgFastForwardOutlined;

export { FastForwardOutlined_default as default };
